/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { useGetCurrentModel } from "hooks/useGetCurrentModel";
import { useAuth } from "cms/auth/hooks/use-auth";
import { RichTextPreview } from "cms/rich-text/simplicity-composer-tiptap/index";

const TableOfContents = (props) => {
    
    const { richtext } = props;
    const { token } = useAuth();
    const model = useGetCurrentModel();
    
    const [loading,setLoading] = useState(false);
    const [chapters,setChapters] = useState([]);
    

    useEffect(() => {
        const fetchChapters = async (token) => {
            setLoading(true);
            const { guid } = model || {};
            const toc = await SimpliCityAdminSDK.model.toc(token, guid);
            const { chapters } = toc;
            setChapters(chapters);
            setLoading(false);
        };
        fetchChapters(token);
    }, [token,model]);
    
    return (
        <>
            {!loading && chapters &&
                <div className='table-of-contents'>
                    <RichTextPreview richtext={richtext} />
                    
                    {chapters && chapters.map((item, index) => {
                        const { chapter, target } = item || {};
                        return (
                            <li key={`${target}${index}`}>
                                <a href={`#${target}`}>
                                    {chapter}
                                </a>
                            </li>
                        );
                    })}
                </div>
            }
        </>
    );
};

TableOfContents.displayName = "TableOfContents";
export { TableOfContents };
